import type { FC } from "react";

import {
  ValidationWrapper,
  type ValidationWrapperProps,
} from "../../../common-ui/form-fields/ValidationWrapper";
import type {
  CreateIntermodalBookingFormModel,
  CreateIntermodalBookingGoodFormModel,
} from "../../../services/intermodal/createIntermodalReducer";
import { useCreateIntermodalField } from "../hooks/useCreateIntermodalField";
import { useCreateIntermodalGoodsField } from "../hooks/useCreateIntermodalGoodsFields";

interface CreateIntermodalValidationWrapperProps extends Omit<
  ValidationWrapperProps,
  "validationError"
> {
  name: keyof CreateIntermodalBookingFormModel;
}

export const CreateIntermodalValidationWrapper: FC<
  CreateIntermodalValidationWrapperProps
> = ({ name, ...props }) => {
  const { validationError } = useCreateIntermodalField(name);
  return <ValidationWrapper validationError={validationError} {...props} />;
};

interface CreateIntermodalGoodsValidationWrapperProps extends Omit<
  ValidationWrapperProps,
  "validationError"
> {
  goodId: string;
  name: keyof CreateIntermodalBookingGoodFormModel;
}

export const CreateIntermodalGoodsValidationWrapper: FC<
  CreateIntermodalGoodsValidationWrapperProps
> = ({ name, goodId, ...props }) => {
  const { validationError } = useCreateIntermodalGoodsField(goodId, name);
  return <ValidationWrapper validationError={validationError} {...props} />;
};
